<template>
  <div class="sm-bank-account" :class="{'sm-default-bank-account': bankAccount.acc.default}">
    <div class="sm-bank-account__header">
      <h6>{{bankAccount.acc.bank_name}}</h6>
      <a
        v-if="!bankAccount.acc.default"
        href="#"
        class="sm-small"
        @click.prevent="$emit('default')"
      >Set as default</a>
    </div>
    <p><span>xx xxxx xxxx xxxxxx xxxx&nbsp;</span>{{bankAccount.acc.last4}}</p>
    <p class="sm-txt-upper">{{bankAccount.acc.currency}}</p>
    <div class="sm-bank-account__footer">
      <p class="sm-bank-account__footer-actions">
       
        <a
          v-if="canDelete"
          href="#"
          class="sm-small sm-error"
          @click.prevent="$emit('delete')"
        >Delete</a>
        <plaid-wrap
          v-if="canUpdate && bankAccount.link && bankAccount.link.link_token"
          :linkToken="bankAccount.link.link_token"
          @success="data => $emit('update', data)"
        >
          <template slot="button">
            <button class="sm-small sm-grey-link">Update</button>
          </template>
        </plaid-wrap>
      </p>
      <p :class="`sm-bank-account__footer-logo sm-bank-logo ${formattedBankName}`"></p>
    </div>
  </div>
</template>

<script>
import PlaidWrap from '@/components/bank-account/PlaidWrap';

export default {
  name: 'bank-account',
  components: {
    'plaid-wrap': PlaidWrap
  },
  props: {
    bankAccount: {
      type: Object,
      required: true
    },
    canUpdate: {
      type: Boolean,
      default: true
    },
    canDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      
    }
  },
  computed: {
    formattedBankName() {
      if (!this.bankAccount.acc.bank_name)
        return '';

      return this.bankAccount.acc.bank_name
        .replace(/ /g, '_')
        .replace(/\&/g, 'n')
        .toLowerCase();
    }
  }
}
</script>